import React, { useState, useEffect } from 'react';
import ModernTimeDropdown from './modernDropdown';

const AddSampleModal = ({ showType = 'Module', moduleName = '', callId='', onCancel, onSave }) => {
  const [formState, setFormState] = useState({
    call_id: '',
    module_name: '',
  });

  useEffect(() => {
    setFormState({
      call_id: callId || '',
      module_name: moduleName || '',
    });
  }, [moduleName, callId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState(prev => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleChangeModule = (e) => {
    const { value } = e.target;
    setFormState(prev => ({
      ...prev,
      'module_name': value,
    }));
  };
  const handleCancel = () => {
    onCancel()
  }
  const handleSave = () => {
    onSave(formState)
  }

  return (
    <div className="p-4">
      <div className="mb-4">
        <label className="block text-sm font-medium mb-2">Call ID</label>
        <input
          type="text"
          name="call_id"
          value={formState.call_id}
          onChange={handleChange}
          disabled={showType === 'Call'}
          className={`w-full px-2 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none global-input ${showType === 'Call' ? 'bg-gray-100 cursor-not-allowed' : ''}`}
        />
      </div>

      <div className="mb-4">
        <label className="block text-sm font-medium mb-2">Module Name</label>
        <ModernTimeDropdown value={formState.module_name} width='w-full' onChange={handleChangeModule} isDisabled={showType === 'Module'} 
        options={['CONVERSATION SUMMARY', 'AGENT FEEDBACK', 'CONCERNS AND QUERIES', 'TEMPLATES', 'BUSINESS INSIGHTS', 'LEAD QUALITY', 'CONVERSATION DISPOSITIONS', 'CUSTOM MODULE']}/>
      </div>

        <div className="flex justify-end gap-3 py-6">
            <button onClick={handleCancel} className="px-6 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50" style={{height: "40px", borderRadius: "4px"}}>
                Cancel
            </button>
            <button onClick={handleSave} className="px-6 py-2 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700" style={{height: "40px", borderRadius: "4px"}}>
                Save
            </button>
        </div>
    </div>
  );
};

export default AddSampleModal;
